import { render, staticRenderFns } from "./OAuthConsentPage.vue?vue&type=template&id=c3b2a334&scoped=true&"
import script from "./OAuthConsentPage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OAuthConsentPage.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./OAuthConsentPage.vue?vue&type=style&index=0&id=c3b2a334&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b2a334",
  null
  
)

export default component.exports